import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from '@core/components/base-component';
import { StatusEnum } from '@enums/Status';
import { Estimate } from '@interfaces/Estimate';
import { EstimateImportService } from '../project-import/shared/estimate-import.service';

@Component({
  selector: 'pop-estimate-picker',
  templateUrl: './estimate-picker.component.html',
  styleUrls: ['./estimate-picker.component.less']
})
export class EstimatePickerComponent extends BaseComponent implements OnInit {
  public StatusEnum = StatusEnum;

  @Input() public readonly = false;

  @Input() public importMode = false;
  @Input() public styleClass: 'rem-fix' | '' = '';
  @Input() public style = { width: '350px' };

  public estimates: Estimate[];

  private _selectedEstimate: Estimate;
  @Input() public get selectedEstimate() {
    return this._selectedEstimate;
  }
  public set selectedEstimate(value: Estimate) {
    value = value ?? undefined; // PrimeNG returns null this code avoids ExpressionChangedAfterItHasBeenCheckedError

    if (this._selectedEstimate !== value) {
      this._selectedEstimate = value;
      this.selectedEstimateChange.emit(value);
    }
  }

  @Output() public selectedEstimateChange = new EventEmitter<Estimate>();

  private estimateItems: Estimate[];

  private _estimateFilter: (Estimate: Estimate) => boolean;
  @Input() public get estimateFilter() {
    return this._estimateFilter;
  }

  public set estimateFilter(value: (Estimate: Estimate) => boolean) {
    this._estimateFilter = value;
    this.filter();
  }

  public constructor(private estimateImportService: EstimateImportService) {
    super();
  }

  public ngOnInit() {
    this.subscribe(
      this.estimateImportService.getEstimates(true).subscribe(estimates => {
        this.estimateItems = estimates;
        this.filter();
      })
    );
  }

  public filter() {
    if (this.estimateFilter) {
      this.estimates = this.estimateItems?.filter(dto => this.estimateFilter(dto));
    } else {
      this.estimates = this.estimateItems;
    }
  }
}
